import React, {useState, useContext, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {Context} from '../../context';
import TableForDesktopAndMobile from '../UI/TableForDesktopAndMobile';
import {
  getDateString,
  dollarAmount,
  getExpiryDate,
  getTicketStatus,
  getAllTickets
} from '../../helperFunctions';

const UsageHistory = () => {
  const {account, localeText, getTicketName, locale, mobileFilter} =
    useContext(Context);
  const {ticketUuid} = useParams();
  const [scanHistory, setScanHistory] = useState([]);
  const [ticketInfo, setTicketInfo] = useState([]);

  useEffect(() => {
    const transitCards = account?.transitAccounts?.[0]?.transitCards || [];

    setScanHistory(
      transitCards
        .filter(({scans}) => scans !== null)
        .reduce(
          (prevScans, transitCard) => [
            ...prevScans,
            ...transitCard.scans.filter(
              scan =>
                typeof scan?.mediaId === 'string' &&
                typeof ticketUuid === 'string' &&
                scan.mediaId.toUpperCase() === ticketUuid.toUpperCase()
            )
          ],
          []
        )
    );

    const tickets = getAllTickets(account, mobileFilter);
    if (tickets.length === 0) {
      return;
    }
    const foundTicket = tickets.find(ticket => ticket.uuid === ticketUuid);

    const ticket = [
      {
        key: localeText('rw_title_ticket_id', 'Ticket ID'),
        value: foundTicket.id
      }, // TODO add to phrase data
      {
        key: localeText('rw_title_description', 'Description'),
        value: getTicketName(foundTicket.productId)
      },
      {
        key: localeText('rw_title_transit_card', 'Transit Card'),
        value: account?.transitAccounts?.[0]?.transitCards?.find(tc =>
          tc.tickets?.find(ticket => ticket.uuid === ticketUuid)
        )?.nickname
      },
      {
        key: localeText('rw_title_activation', 'Activation'), // TODO add to phrase data
        value: foundTicket.validFromDateTime
          ? getDateString(foundTicket.validFromDateTime)
          : localeText('rw_msg_not_activated', 'Not Activated') // TODO add to phrase data
      },
      {
        key: localeText('rw_title_expiry', 'Expiry'), // TODO add to Phrase Data
        value: getExpiryDate(
          foundTicket.validToDateTime,
          foundTicket.sunsetDateTime
        )
      },
      {
        key: localeText('rw_title_status', 'Status'),
        value: getTicketStatus(localeText, foundTicket)
      }
    ];

    setTicketInfo(ticket);
  }, [account, locale]);
  return (
    <React.Fragment>
      <h1 className='font-bold mt-0 mb-4'>
        {localeText('rw_header_usage_history', 'Usage History')}
      </h1>
      <table>
        <tbody className=''>
          {ticketInfo.map(({key, value}, index) => (
            <tr key={index}>
              <td className='pb-2 font-bold'>{key}</td>
              <td className='pb-2 pl-4'>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {scanHistory.length > 0 ? (
        <div className='mt-4 p-4 border border-black w-fit'>
          <TableForDesktopAndMobile
            properties={[
              {
                title: localeText('Scan Id'), // TODO add to phrase data
                value: tableItem => tableItem.id
              },
              {
                title: localeText('rw_title_description', 'Description'),
                value: tableItem => getTicketName(tableItem.productId)
              },
              {
                title: localeText('rw_title_location', 'Location'),
                value: tableItem => tableItem.stationName
              },
              {
                title: localeText('rw_title_date', 'Date'),
                value: tableItem => getDateString(tableItem.created)
              },
              {
                title: localeText('rw_title_amount', 'Amount'),
                value: tableItem => dollarAmount(tableItem.tripCost)
              }
            ]}
            tableItems={scanHistory}
          />
        </div>
      ) : (
        <div className='mt-4'>
          {
            localeText('No Scan History') // TODO add to phrase data
          }
        </div>
      )}
    </React.Fragment>
  );
};

export default UsageHistory;
